import React, { useState } from 'react';
import { Sun, Moon } from 'lucide-react';

const read = () => document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';

const ThemeToggle = () => {
  const [theme, setTheme] = useState(read);
  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    const root = document.documentElement;
    root.classList.add('theme-fade');
    root.dataset.theme = next;
    setTimeout(() => root.classList.remove('theme-fade'), 450);
    try { localStorage.setItem('theme', next); } catch (e) { /* private mode */ }
    setTheme(next);
  };
  return (
    <button onClick={toggle} aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`} className="w-11 h-11 grid place-items-center rounded-full border border-[var(--line-strong)] text-[var(--muted)] hover:text-[var(--paper)] hover:border-[var(--paper)] transition-colors">
      {theme === 'dark' ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
};

export default ThemeToggle;
